import { render } from "./ReviewComponent.vue?vue&type=template&id=7400959f&scoped=true&ts=true"
import script from "./ReviewComponent.vue?vue&type=script&lang=ts"
export * from "./ReviewComponent.vue?vue&type=script&lang=ts"

import "./ReviewComponent.vue?vue&type=style&index=0&id=7400959f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7400959f"]])

export default __exports__